import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'atlas-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() text: string;
  @Input() loading: string;
  @Input() disabled: boolean;
  @Input() raised: boolean;

  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  onButtonClick(event: Event): void {
    this.onClick.emit();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
}
